// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"burger-ingredient_wrapper__e224z","price":"burger-ingredient_price__3Iim6","counter":"burger-ingredient_counter__3I-X9","link":"burger-ingredient_link__Rc31N"};